import React, { ChangeEvent } from 'react'
import { generatePath, Link as RouterLink } from 'react-router-dom'
import { ArrowLeftIcon, Button, SearchBox, SelectableChip } from '@diversioteam/diversio-ds'

import { useGetPulseSurveysTemplates } from 'hooks/pulseSurveys/useGetPulseSurveysTemplates'
import { TemplateFilterOption } from '../context/TemplatesContext.types'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { AppRoute } from 'routing/AppRoute.enum'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

import { TEMPLATE_TYPES_FILTERS } from './../templates.helpers'
import { useTemplates } from './../hooks/useTemplates'
import * as S from './filters.styles'

export const Filters = () => {
    const { searchValue, onChangeSearchValue, selectedTemplateTypes, onChangeSelectedTemplateTypes } = useTemplates()

    const { activePulseSurvey } = usePulseSurveys()

    const queryGetPulseSurveysTemplates = useGetPulseSurveysTemplates()

    const hasTemplateTypesSelected = selectedTemplateTypes.length > 0

    const allTemplatesCount = queryGetPulseSurveysTemplates.data?.count

    const handleChangeResourceType = (event: ChangeEvent<HTMLInputElement>, filterOption?: TemplateFilterOption) => {
        const { value, checked } = event.target

        if (value === 'ALL') {
            return onChangeSelectedTemplateTypes([])
        }

        if (!filterOption) return

        const isSelectAllState = selectedTemplateTypes.length === TEMPLATE_TYPES_FILTERS.length - 1

        if (checked || !hasTemplateTypesSelected) {
            const updatedTemplateTypes = isSelectAllState ? [] : [...selectedTemplateTypes, filterOption]

            onChangeSelectedTemplateTypes(updatedTemplateTypes)
        } else {
            const updatedTemplateTypes = selectedTemplateTypes.filter(
                (selectedTemplateType) => selectedTemplateType.value.toString() !== value,
            )

            onChangeSelectedTemplateTypes(updatedTemplateTypes)
        }
    }

    const getMySurveysRedirectTo = () => {
        if (activePulseSurvey) {
            return generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: activePulseSurvey.uuid }))
        }

        return generateCompanyURI(AppRoute.PulseSurvey)
    }

    return (
        <S.FiltersWrapper>
            <S.Filters>
                <S.FiltersGroup>
                    <Button
                        component={RouterLink}
                        to={getMySurveysRedirectTo()}
                        color="secondaryLight"
                        leftIcon={<ArrowLeftIcon type="line" />}
                        fullWidth
                    >
                        My Surveys
                    </Button>

                    <SearchBox
                        value={searchValue}
                        onChange={onChangeSearchValue}
                        defaultExpanded
                        keepExpanded
                        placeholder="Search"
                    />
                </S.FiltersGroup>

                {TEMPLATE_TYPES_FILTERS && (
                    <S.FiltersGroup>
                        <S.FiltersGroupTitle>Template Type</S.FiltersGroupTitle>

                        <S.FormGroup as="ul">
                            <S.FormGroupItem>
                                <SelectableChip
                                    variant="outlined"
                                    size="small"
                                    focused={!hasTemplateTypesSelected}
                                    selected={!hasTemplateTypesSelected}
                                    name="ALL"
                                    label={`All${allTemplatesCount ? ` (${allTemplatesCount})` : ''}`}
                                    value="ALL"
                                    onChange={(event) => handleChangeResourceType(event)}
                                />
                            </S.FormGroupItem>

                            {TEMPLATE_TYPES_FILTERS.map((filterOption) => {
                                const { label, value } = filterOption

                                const isOptionSelected =
                                    selectedTemplateTypes.findIndex(
                                        (selectedTemplateType) => selectedTemplateType.value === value,
                                    ) !== -1

                                return (
                                    <S.FormGroupItem key={value}>
                                        <SelectableChip
                                            variant="outlined"
                                            size="small"
                                            focused={isOptionSelected}
                                            selected={isOptionSelected || !handleChangeResourceType}
                                            name={value.toString()}
                                            label={label}
                                            value={value}
                                            onChange={(event) => handleChangeResourceType(event, filterOption)}
                                        />
                                    </S.FormGroupItem>
                                )
                            })}
                        </S.FormGroup>
                    </S.FiltersGroup>
                )}
            </S.Filters>
        </S.FiltersWrapper>
    )
}
